module.exports = __webpack_public_path__ + "AM.png?051ba42b17a355eef367450ec139c9fb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/AM.png
// module id = 328
// module chunks = 0